import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hd-navigation hd-container", `hd-navigation--${_ctx.modifier}`])
  }, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["hd-navigation__button hd-navigation__button--left", { 'is-inactive': _ctx.prevPath === '' }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo(_ctx.prevPath))),
      "data-analytics-name": "navigation",
      "data-analytics-id": "prev"
    }, [
      _createVNode(_component_base_image_svg, {
        class: "hd-navigation__icon",
        source: require('!html-loader!@/ui/assets/icons/chevron-left.svg')
      }, null, 8, ["source"]),
      _createVNode(_component_lyra_asset, {
        class: "hd-navigation__link",
        "asset-key": _ctx.namePrevPath
      }, null, 8, ["asset-key"])
    ], 2), [
      [_vShow, _ctx.prevPath !== '']
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["hd-navigation__button hd-navigation__button--right", { 'is-inactive': _ctx.nextPath === '' }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo(_ctx.nextPath))),
      "data-analytics-name": "navigation",
      "data-analytics-id": "next"
    }, [
      _createVNode(_component_lyra_asset, {
        class: "hd-navigation__link",
        "asset-key": _ctx.nameNextPath
      }, null, 8, ["asset-key"]),
      _createVNode(_component_base_image_svg, {
        class: "hd-navigation__icon",
        source: require('!html-loader!@/ui/assets/icons/chevron-right.svg')
      }, null, 8, ["source"])
    ], 2), [
      [_vShow, _ctx.nextPath !== '']
    ])
  ], 2))
}